import { navigateToUrl } from 'single-spa';
import { tokenStore } from '../store';
import {
  isRouteAnonymous,
  shouldDenyEntryForAuthedUser
} from './is-route-anonymous';

const { getToken, checkIsExpired, clearToken } = tokenStore();

export const checkAuth = () => {
  const storedToken = getToken();
  const isValidToken = storedToken ? !checkIsExpired(storedToken) : false;

  if (!isValidToken && !isRouteAnonymous(location.pathname)) {
    clearToken();
    navigateToUrl(`${location.origin}/login`);

    location.reload();
  }

  if (!isValidToken && isRouteAnonymous(location.pathname)) {
    return;
  }

  if (shouldDenyEntryForAuthedUser(location.pathname)) {
    navigateToUrl(`${location.origin}/`);

    return;
  }

  return;
};
